import { createAsyncThunk } from '@reduxjs/toolkit';
import { PersonHistoryFetch } from './History.type';
import personHistoryService from './History.service';

export const getPersonRecordHistoryLinkThunk = createAsyncThunk(
  'personHistory/getPersonRecordHistoryLinkThunk',
  async (params: PersonHistoryFetch, thunkApi) => {
    const response = await personHistoryService.getList(params);
    return response.data;
  },
);
